import { Check, Circle, Dot } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Card, CardContent } from '@/components/ui/card'

/** Cómo se pinta cada estado de un ítem de la checklist. */
const ESTILO_ESTADO = {
  sin_empezar: { icono: Circle, clase: 'text-neutral-300 dark:text-neutral-600' },
  en_progreso: { icono: Dot, clase: 'text-warning-700 dark:text-warning-300' },
  completo: { icono: Check, clase: 'text-success-600 dark:text-success-300' },
}

/**
 * LA CHECKLIST CORTA — no las 20 entidades técnicas del motor, un puñado de categorías de
 * negocio ("Catálogo de productos", "Clientes con saldo") derivadas de lo que ya se clasificó.
 *
 * Es lo que le permite al asesor decir "te faltan 2 cosas" sin tener que leer la lista técnica
 * completa, y lo que hace legible el botón de pausar: sin esto, "guardar y continuar después"
 * no dice nada sobre qué falta.
 */
export default function ChecklistMigracion({ checklist = [] }) {
  if (checklist.length === 0) return null

  const completos = checklist.filter((c) => c.estado === 'completo').length

  return (
    <Card>
      <CardContent className="space-y-3 py-4">
        <div className="flex items-center justify-between">
          <p className="text-caption font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400">Pendientes</p>
          <p className="text-caption text-neutral-500 dark:text-neutral-400">
            {completos} de {checklist.length}
          </p>
        </div>
        <ul className="space-y-2">
          {checklist.map((item) => {
            const estilo = ESTILO_ESTADO[item.estado] || ESTILO_ESTADO.sin_empezar
            const Icono = estilo.icono
            return (
              <li key={item.categoria} className="flex items-center gap-2">
                <Icono size={16} className={cn('shrink-0', estilo.clase)} />
                <span
                  className={cn(
                    'flex-1 text-body-sm',
                    item.estado === 'completo' ? 'text-neutral-500 dark:text-neutral-400 line-through' : 'text-neutral-800 dark:text-neutral-200'
                  )}
                >
                  {item.etiqueta}
                </span>
                {item.estado === 'en_progreso' && (
                  <span className="text-caption text-neutral-400 dark:text-neutral-500">
                    {item.hojasListas} de {item.hojasTotal}
                  </span>
                )}
              </li>
            )
          })}
        </ul>
      </CardContent>
    </Card>
  )
}
